module.exports = __webpack_public_path__ + "img/todo_2.35f09f23.png";